// A character's standing powers that need the DM's judgement (issue 1172; docs/MRCS/shadowrun-3.md §15), under its
// token's Actions: each power its sheet lists whose entry says the DM judges it (one that changes how the world reacts),
// with its level and its rule. The server reads the sheet's rows and the entries, for the DM or the token's owner;
// a power that changes a number is counted where the number is used, so it is not listed here.
import { useEffect, useState } from 'react';
import type { StandingPower } from '@dragons-table/vtt-shared';
import { fetchStanding } from '../../entries';
import { useTableState } from '../../table/TableState';
import { useShell } from '../context';
import { useMayAct } from '../../table/mayAct';

interface Thing { id: string; kind: string; mine?: boolean; character?: string | null }

export function StandingPowers({ o }: { o: Thing }) {
  const { systemRules, scene } = useTableState();
  const { campaignId } = useShell();
  const isDm = useMayAct()('attack.request');
  const [powers, setPowers] = useState<StandingPower[]>([]);
  const may = Boolean(o.character && systemRules.spellcasting?.standingPowers && (isDm || o.mine));
  useEffect(() => {
    setPowers([]);
    if (!may) return undefined;
    let live = true;
    void fetchStanding(campaignId, o.id, scene?.id ?? null).then((a) => { if (live) setPowers((a?.powers ?? []).filter((p) => p.judged)); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [o.id, o.character, may, campaignId]);
  if (!powers.length) return null;
  return (
    <div className="space-y-0.5 text-xs" data-testid="standing-powers">
      <p className="text-stone-400">Powers the DM judges:</p>
      {powers.map((p) => (
        <p key={p.ref} className="text-stone-300"><span className="text-violet-200">{p.name}{p.levels > 1 ? ` ${p.levels}` : ''}</span>{p.effect ? `: ${p.effect}` : ''}</p>
      ))}
    </div>
  );
}
